export default __webpack_public_path__ + "static/media/et-sn.0a52b079.svg";